import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { logError } from "@faire/web--source/common/logging";
import { useMutation as usePostClickedNotification } from "@faire/web-api--source/api/retailer/notifications/click/post-hooks";
import { useMutation as usePostDismissedNudge } from "@faire/web-api--source/api/retailer/notifications/dismiss-nudge/post-hooks";
import { useMutation as usePostDismissedNotification } from "@faire/web-api--source/api/retailer/notifications/dismiss/post-hooks";
import { useInvalidateQuery as useInvalidateGetNotificationQuery } from "@faire/web-api--source/api/retailer/notifications/get-hooks";
import { useMutation as usePostViewedNotification } from "@faire/web-api--source/api/retailer/notifications/view/post-hooks";
import { IClickNotificationRequest } from "@faire/web-api--source/indigofair/retailer/IClickNotificationRequest";
import { IDismissNotificationNudgeRequest } from "@faire/web-api--source/indigofair/retailer/IDismissNotificationNudgeRequest";
import { IDismissNotificationRequest } from "@faire/web-api--source/indigofair/retailer/IDismissNotificationRequest";
import { IViewNotificationRequest } from "@faire/web-api--source/indigofair/retailer/IViewNotificationRequest";
import { useCallback } from "react";
export var useSetNotificationState = function(token) {
    var _usePostViewedNotification = usePostViewedNotification(), viewedNotification = _usePostViewedNotification.mutateAsync;
    var _usePostDismissedNotification = usePostDismissedNotification(), dismissedNotification = _usePostDismissedNotification.mutateAsync;
    var _usePostDismissedNudge = usePostDismissedNudge(), dismissedNudge = _usePostDismissedNudge.mutateAsync;
    var _usePostClickedNotification = usePostClickedNotification(), clickedNotification = _usePostClickedNotification.mutateAsync;
    var invalidateGetNotificationQuery = useInvalidateGetNotificationQuery();
    var setNotificationHasBeenViewed = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        viewedNotification([
                            IViewNotificationRequest.build({
                                notification_token: token
                            })
                        ])
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    logError("Unable to set notification as viewed");
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        token,
        viewedNotification
    ]);
    var setNotificationHasBeenDismissed = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        dismissedNotification([
                            IDismissNotificationRequest.build({
                                notification_token: token
                            })
                        ], {
                            onSuccess: function() {
                                return invalidateGetNotificationQuery();
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    logError("Unable to set notification as dismissed");
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        dismissedNotification,
        invalidateGetNotificationQuery,
        token
    ]);
    var setNudgeHasBeenDismissed = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        dismissedNudge([
                            IDismissNotificationNudgeRequest.build({
                                notification_token: token
                            })
                        ], {
                            onSuccess: function() {
                                return invalidateGetNotificationQuery();
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    logError("Unable to set nudge as dismissed");
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        dismissedNudge,
        invalidateGetNotificationQuery,
        token
    ]);
    var setNotificationHasBeenClicked = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        clickedNotification([
                            IClickNotificationRequest.build({
                                notification_token: token
                            })
                        ])
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    logError("Unable to set notification as clicked");
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        clickedNotification,
        token
    ]);
    return {
        setNotificationHasBeenViewed: setNotificationHasBeenViewed,
        setNotificationHasBeenDismissed: setNotificationHasBeenDismissed,
        setNotificationHasBeenClicked: setNotificationHasBeenClicked,
        setNudgeHasBeenDismissed: setNudgeHasBeenDismissed
    };
};
